import Logo from "images/rs-logo.svg";
import { Spinner } from "UI/Spinner";
import ProfileMobileButton from "images/profile-mobile-button.svg";

export const LayoutSkeleton = () => {
  return (
    <div className="flex flex-col xl:flex-row 2xl:flex-row xl:justify-between 2xl:justify-between bg-gray-100 px-2 py-4 min-h-screen">
      <div className="relative bg-white min-w-80 min-h-60 w-100 rounded-xl m-4 shadow p-4 hidden sm:hidden md:flex lg:flex xl:flex 2xl:flex flex-col sm:flex-col md:flex-col lg:flex-col xl:flex-row 2xl:flex-row justify-stretch items-stretch">
        <img
          src={Logo}
          className="w-16 absolute top-4 left-4"
          alt="referral stream logo"
        />
      </div>
      <div className="content flex-col hidden sm:hidden md:flex lg:flex xl:flex 2xl:flex flex-grow bg-white rounded-xl m-4 shadow p-8">
        <Spinner />
      </div>
      <div className="bg-white rounded-xl m-4 shadow p-4 flex flex-row justify-between md:hidden xl:hidden 2xl:hidden">
        <img src={Logo} className="w-16" alt="referral stream logo" />
        <img
          src={ProfileMobileButton}
          className="w-10 cursor-pointer hover:opacity-80"
          alt="profile button"
        />
      </div>
      <div className="md:hidden lg:hidden xl:hidden 2xl:hidden flex-1 flex flex-row items-stretch">
        <div className="content flex-grow bg-white rounded-xl m-4 shadow p-4">
          <Spinner />
        </div>
      </div>
    </div>
  );
};
